import R from 'ramda';
import {combineReducers} from "redux";

import {
    MARATHONS_FORM_DATA_CHANGED,
    MARATHONS_LANGUAGE_FETCHING,
    MARATHONS_LANGUAGE_SELECTED,
    MARATHONS_REGISTER,
    MARATHONS_REVIEWS_FETCHING,
    MARATHONS_SHOW_FULL_SELECTOR,
    MARATHONS_SHOW_REGISTRATION,
    MARATHONS_RESET_ERROR,
    MARATHONS_WAY_UPDATED,
} from './actions';
import { fulfilled, pending, rejected } from '../utils/actions';

function languages(state = [], action) {
    switch (action.type) {
        case fulfilled(MARATHONS_LANGUAGE_FETCHING):
            return [...action.payload];
        default:
            return state;
    }
}

function reviews(state = [], action) {
    switch (action.type) {
        case fulfilled(MARATHONS_REVIEWS_FETCHING):
            return [...action.payload];
        default:
            return state;
    }
}

function currentLanguage(state = null, action) {
    switch (action.type) {
        case MARATHONS_LANGUAGE_SELECTED:
            return action.payload;
        default:
            return state;
    }
}

function showFullSelector(state = false, action) {
    switch (action.type) {
        case MARATHONS_SHOW_FULL_SELECTOR:
            return action.payload;
        default:
            return state;
    }
}

function showRegistration(state = false, action) {
    switch (action.type) {
        case MARATHONS_SHOW_REGISTRATION:
            return action.payload;
        default:
            return state;
    }
}

function currentWay(state = 'FREE', action) {
    switch (action.type) {
        case MARATHONS_WAY_UPDATED:
            return action.payload;
        default:
            return state;
    }
}

function data(state = {}, action) {
    switch (action.type) {
        case MARATHONS_FORM_DATA_CHANGED:
            return { ...state, [action.payload.key]: action.payload.value };
        default:
            return state;
    }
}

function registration(state = { errors: {} }, action) {
    switch (action.type) {
        case pending(MARATHONS_REGISTER):
            return { errors: {}, pending: true };
        case rejected(MARATHONS_REGISTER):
            return { errors: action.payload.data || {}, pending: false };
        case MARATHONS_RESET_ERROR:
            return R.has(action.payload, state.errors)
                ? { ...state, errors: R.omit([action.payload], state.errors) }
                : state;
        default:
            return state;
    }
}

export default combineReducers({
    languages,
    reviews,
    currentLanguage,
    showFullSelector,
    currentWay,
    showRegistration,
    data,
    registration,
})



// WEBPACK FOOTER //
// ./src/marathons/reducers.js